<template>
  <TableLayout :permissions="['business:notices:query']">
    <!-- 搜索表单 -->
    <SearchFormCollapse slot="search-form">
      <el-form ref="searchForm" :model="searchForm" label-width="100px" inline>
        <el-form-item label="主键" prop="id">
          <el-input v-model="searchForm.id" placeholder="请输入主键" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="创建人编码" prop="creator">
          <el-input v-model="searchForm.creator" placeholder="请输入创建人编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="创建时间" prop="createDate">
          <el-date-picker v-model="searchForm.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间" @change="search"/>
        </el-form-item>
        <el-form-item label="更新人编码" prop="editor">
          <el-input v-model="searchForm.editor" placeholder="请输入更新人编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="更新时间" prop="editDate">
          <el-date-picker v-model="searchForm.editDate" value-format="yyyy-MM-dd" placeholder="请输入更新时间" @change="search"/>
        </el-form-item>
        <el-form-item label="是否删除0否 1是" prop="isdeleted">
          <el-input v-model="searchForm.isdeleted" placeholder="请输入是否删除0否 1是" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="searchForm.remark" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="searchForm.title" placeholder="请输入标题" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="简介" prop="info">
          <el-input v-model="searchForm.info" placeholder="请输入简介" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input v-model="searchForm.content" placeholder="请输入内容" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="关联对象编码" prop="objId">
          <el-input v-model="searchForm.objId" placeholder="请输入关联对象编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="关联对象类型 0工单" prop="objType">
          <el-input v-model="searchForm.objType" placeholder="请输入关联对象类型 0工单" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="关联对象名称" prop="objName">
          <el-input v-model="searchForm.objName" placeholder="请输入关联对象名称" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="类型 0工单上报 1工单分配物业主管 2SHE工单抄送  3工单处理催促 4工单分配处理人" prop="type">
          <el-input v-model="searchForm.type" placeholder="请输入类型 0工单上报 1工单分配物业主管 2SHE工单抄送  3工单处理催促 4工单分配处理人" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="关联参数1" prop="param1">
          <el-input v-model="searchForm.param1" placeholder="请输入关联参数1" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="关联参数2" prop="param2">
          <el-input v-model="searchForm.param2" placeholder="请输入关联参数2" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="关联参数3" prop="param3">
          <el-input v-model="searchForm.param3" placeholder="请输入关联参数3" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="关联参数4" prop="param4">
          <el-input v-model="searchForm.param4" placeholder="请输入关联参数4" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="关联参数5" prop="param5">
          <el-input v-model="searchForm.param5" placeholder="请输入关联参数5" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="关联用户姓名" prop="memberName">
          <el-input v-model="searchForm.memberName" placeholder="请输入关联用户姓名" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="关联用户企微编码" prop="qwId">
          <el-input v-model="searchForm.qwId" placeholder="请输入关联用户企微编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="关联用户编码（关联member)" prop="memberId">
          <el-input v-model="searchForm.memberId" placeholder="请输入关联用户编码（关联member)" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="关联企业组织编码(关联company）" prop="companyId">
          <el-input v-model="searchForm.companyId" placeholder="请输入关联企业组织编码(关联company）" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="状态 0正常 1已关闭" prop="status">
          <el-input v-model="searchForm.status" placeholder="请输入状态 0正常 1已关闭" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="是否抄送 0不是 1是" prop="sendacopy">
          <el-input v-model="searchForm.sendacopy" placeholder="请输入是否抄送 0不是 1是" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="是否已读 0未读 1已读" prop="readed">
          <el-input v-model="searchForm.readed" placeholder="请输入是否已读 0未读 1已读" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <section>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </section>
      </el-form>
    </SearchFormCollapse>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:notices:create', 'business:notices:delete']">
        <li><el-button type="primary" @click="$refs.operaNoticesWindow.open('新建系统消息信息表')" icon="el-icon-plus" v-permissions="['business:notices:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:notices:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="主键" min-width="100px"></el-table-column>
        <el-table-column prop="creator" label="创建人编码" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="editor" label="更新人编码" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="更新时间" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否删除0否 1是" min-width="100px"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="title" label="标题" min-width="100px"></el-table-column>
        <el-table-column prop="info" label="简介" min-width="100px"></el-table-column>
        <el-table-column prop="content" label="内容" min-width="100px"></el-table-column>
        <el-table-column prop="objId" label="关联对象编码" min-width="100px"></el-table-column>
        <el-table-column prop="objType" label="关联对象类型 0工单" min-width="100px"></el-table-column>
        <el-table-column prop="objName" label="关联对象名称" min-width="100px"></el-table-column>
        <el-table-column prop="type" label="类型 0工单上报 1工单分配物业主管 2SHE工单抄送  3工单处理催促 4工单分配处理人" min-width="100px"></el-table-column>
        <el-table-column prop="param1" label="关联参数1" min-width="100px"></el-table-column>
        <el-table-column prop="param2" label="关联参数2" min-width="100px"></el-table-column>
        <el-table-column prop="param3" label="关联参数3" min-width="100px"></el-table-column>
        <el-table-column prop="param4" label="关联参数4" min-width="100px"></el-table-column>
        <el-table-column prop="param5" label="关联参数5" min-width="100px"></el-table-column>
        <el-table-column prop="memberName" label="关联用户姓名" min-width="100px"></el-table-column>
        <el-table-column prop="qwId" label="关联用户企微编码" min-width="100px"></el-table-column>
        <el-table-column prop="memberId" label="关联用户编码（关联member)" min-width="100px"></el-table-column>
        <el-table-column prop="companyId" label="关联企业组织编码(关联company）" min-width="100px"></el-table-column>
        <el-table-column prop="status" label="状态 0正常 1已关闭" min-width="100px"></el-table-column>
        <el-table-column prop="sendacopy" label="是否抄送 0不是 1是" min-width="100px"></el-table-column>
        <el-table-column prop="readed" label="是否已读 0未读 1已读" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:notices:update', 'business:notices:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaNoticesWindow.open('编辑系统消息信息表', row)" icon="el-icon-edit" v-permissions="['business:notices:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:notices:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaNoticesWindow ref="operaNoticesWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import SearchFormCollapse from '@/components/common/SearchFormCollapse'
import Pagination from '@/components/common/Pagination'
import OperaNoticesWindow from '@/components/business/OperaNoticesWindow'
export default {
  name: 'Notices',
  extends: BaseTable,
  components: { SearchFormCollapse, TableLayout, Pagination, OperaNoticesWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        remark: '',
        title: '',
        info: '',
        content: '',
        objId: '',
        objType: '',
        objName: '',
        type: '',
        param1: '',
        param2: '',
        param3: '',
        param4: '',
        param5: '',
        memberName: '',
        qwId: '',
        memberId: '',
        companyId: '',
        status: '',
        sendacopy: '',
        readed: ''
      }
    }
  },
  created () {
    this.config({
      module: '系统消息信息表',
      api: '/business/notices',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
